// extracted by mini-css-extract-plugin
export default {"container":"LFRKo9","cardDivider":"UT_9DR","hideDivider":"lXJ3NI","listDividerColor":"Lgwamt","cardBorderColor":"o1s24v","listHoveredBorderColor":"jVBq6Q"};